<template>
  <div class="dashboard">
    <Loader :loading="loading" loading-text="please wait..." />
    <main class="page-content">
      <header class="welcome-text mb-3 ml-2 ml-lg-0">
        Loan Request -
        <span class="transfer-option">Personal Information</span>
      </header>

      <div class="statement-container">
        <!-- back-home -->
        <div class="back-home" style="cursor:pointer" @click="$router.go(-1)">
          <span>
            <i class="fal fa-long-arrow-left icon"></i>
          </span>
          <!-- <span><i class="fal fa-arrow-left icon fa-2x"></i></span> -->
        </div>

        <!-- form start -->
        <h6>Personal Infoormation</h6>

        <ValidationObserver v-slot="{ passes }">
          <form @submit.prevent="passes(postLoan)">
            <div class="tab-contents">
              <div class="form-row">
                <div class="col-md-5 mt-3">
                  <ValidationProvider
                    name="titlePersonal"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="v">
                      Title
                      <span class="text-danger">*</span>
                    </label>
                    <select
                      v-model="title"
                      class="browser-default custom-select mb-3"
                      placeholder="title"
                      name="title"
                      id="title"
                    >
                      <option value="Mr">Mr.</option>
                      <option value="Mrs">Mrs.</option>
                      <option value="Ms">Ms</option>
                    </select>
                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="form-row first">
                <div class="col-md-5 mb">
                  <ValidationProvider
                    name="firstname"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="v">
                      First Name
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        v-model="firstname"
                        class="form-control"
                        placeholder
                        name="firstname"
                      />
                    </div>
                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>

                <div class="col-md-2"></div>

                <div class="col-md-5 mb">
                  <ValidationProvider
                    name="lastname"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="v">
                      Last Name
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        v-model="lastname"
                        class="form-control"
                        placeholder
                        name="lastname"
                      />
                    </div>
                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="form-row thir mb-3"></div>

              <div class="form-row">
                <div class="col-md-5 mb-3">
                  <ValidationProvider
                    name="address"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="v">
                      Current Address
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        v-model="address"
                        class="form-control"
                        placeholder
                        name="address"
                      />
                    </div>
                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>

                <div class="col-md-2"></div>

                <div class="col-md-5">
                  <ValidationProvider
                    name="account"
                    rules="required|min:11"
                    v-slot="{ errors }"
                  >
                    <label for="v">
                      Account Number
                      <span class="text-danger">*</span>
                    </label>
                    <select
                      v-model="account"
                      class="browser-default custom-select mb-3 mb-sm-0"
                      placeholder="account"
                      name="account"
                      id="account"
                    >
                      <option value="-select Account for Disbursement-"
                        >-select Account for Disbursement-</option
                      >
                      <option value="number"
                        >-select Account for Disbursement-</option
                      >
                      <option value="number"
                        >-select Account for Disbursement-</option
                      >
                    </select>
                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>sonal Information
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="d-flex mt-3 justify-content-start">
              <button
                class="btn btn-primary"
                type="submit"
                @click="$router.push('/Loan-Apply')"
              >
                Next
              </button>
            </div>
          </form>
        </ValidationObserver>

        <!-- success modal -->
        <b-modal hide-footer v-model="modalShow">
          <div class="modal-container text-center">
            <p class="welcome-text">Transaction Successful</p>

            <div>
              <img
                src="../../../assets/images/payment-success.png"
                class="img-fluid"
                width="100px"
                alt
              />
            </div>

            <div>
              <button
                class="btn btn-primary px-4 mt-4"
                @click="modalShow = false"
              >
                Done
              </button>
            </div>
          </div>
        </b-modal>
      </div>
    </main>
  </div>
</template>

<script>
//import VueNumeric from "vue-numeric";
import { clientService } from "../../../services/ClientServices/client.services";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "../../../utils/vue-loader/loader.vue";
//import { mapState } from "vuex";
export default {
  name: "Apply",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loader
    //VueNumeric
  },
  data() {
    return {
      title: "",
      firstname: "",
      lastname: "",
      address: "",
      account: "",
      loading: false
    };
  },
  methods: {
    //Post Loan
    async postLoan() {
      this.loading = true;
      await clientService
        .postLoan({
          amount: this.amount,
          tenor: this.tenor,
          account: this.account,
          purpose: this.loanPurpose,
          bank: this.bank
        })
        .then(res => {
          this.$toastr.s(res.message, "Posted Succesfully");
          this.$router.push("/Loan");
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.$store.dispatch("home");
  }
};
</script>

<style lang="scss" scoped>
.btn-primary {
  background: $main-color;
  border: 1px solid $main-color;
  font-family: $SourceSansPro-Regular;
  width: 100px;
}

.back-home {
  width: 170px;
}
</style>
